import { useQuery } from '@tanstack/react-query';
import { JobsService } from '../services';

/**
 * The shifts that share one transaction id: a shift, and every repost of it
 * (a repost is a new job with its original's transaction_id). Disabled
 * without an id; `isLoading` is false while disabled.
 *
 * `options` adds to the query; it does not replace the shared ones.
 */
export const useJobFamily = (transactionId, options = {}) => {
  const { data, isLoading } = useQuery({
    ...options,
    queryKey: ['jobFamily', transactionId],
    queryFn: () => JobsService.getJobList({ searchText: transactionId }),
    enabled: Boolean(transactionId),
    retry: false,
  });

  return { jobIds: (data?.response ?? []).map((job) => job.id), isLoading };
};
